module.exports = function() {
  return new Worker(__webpack_public_path__ + "a33bf4217a86baa31cb4.worker.js");
};